
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PolygonSpiralsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const count = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1.5 * scale;

        const drawPolygon = (sides: number, r: number) => {
            ctx.beginPath();
            for (let i = 0; i < sides; i++) {
                const a = (i / sides) * Math.PI * 2;
                const px = Math.cos(a) * r;
                const py = Math.sin(a) * r;
                if (i === 0) ctx.moveTo(px, py);
                else ctx.lineTo(px, py);
            }
            ctx.closePath();
            ctx.stroke();
        };

        const draw = () => {
            const sides = 3 + (layerIndex % 4);
            const baseR = 100 * scale * (1 / (layerIndex + 1));
            for (let i = 0; i < count; i++) {
                ctx.save();
                ctx.rotate(i * 0.1 + curTime * 0.2);
                drawPolygon(sides, baseR + i * 20 * scale);
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
